var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueDropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }